// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xDWz","controls":"styles_controls__1Kyk8","charLimit":"styles_charLimit__1JOPf","input":"styles_input__1ONB9","send":"styles_send__216GZ"};